
export class ImageModel {
  constructor(public type: string) {
  }
}

export class Image extends ImageModel {
  public altText?: string;

  constructor(
    public type: string,
    public src: string
  ) {
    super(type);
  }
}

export class ImageFile extends ImageModel {
  constructor(
    public id: string,
    public type: string,
    public file: string
  ) {
    super(type);
  }
}
